<div *ngIf="isMobile; else NormalImages">
  <div *ngFor="let questionImageAndMedia of questionImageAndMedias" class="questionImageMain">
    <div class="col-12">
      <div
        [ngClass]="(questionImageAndMedia?.HPosition == 1) ? 'align-c' : (questionImageAndMedia?.HPosition == 2) ? 'align-c': (questionImageAndMedia?.HPosition == 3) ? 'align-c': '' ">

        <ng-container *ngIf="questionImageAndMedia.IsImage; else MediaControl">
          <app-image-control [imageName]="questionImageAndMedia?.Name" [imagePath]="questionImageAndMedia?.ImagePath"
            [imageRedirectURL]="questionImageAndMedia?.URL ? questionImageAndMedia.URL : undefined "
            [imageCaption]="questionImageAndMedia?.Caption ? questionImageAndMedia.Caption : undefined ">
          </app-image-control>
        </ng-container>
        <ng-template #MediaControl>
          <app-media-control [isLoadFile]="questionImageAndMedia?.IsLoadFile" [mediaName]="questionImageAndMedia?.Name"
            [mediaUrl]="questionImageAndMedia?.URL" [mediaEmbed]="questionImageAndMedia?.VideoEmbedPath"
            [mediaCaption]="questionImageAndMedia?.Caption ? questionImageAndMedia.Caption : undefined">
          </app-media-control>
        </ng-template>
        <div *ngIf="questionImageAndMedia.Caption != null" class="caption">
          {{questionImageAndMedia.Caption}}
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #NormalImages>
  <div *ngFor="let imagesArr of imagesArray; let i = index" class="ques-img-row">
    <ng-container *ngIf="imageSize != 0;else BestFitHandling">
      <div *ngFor="let questionImageAndMedia of imagesArr; let j = index" class="ques-img-row-item"
        [style.width.%]="100/imagesArr.length" [ngClass]="{'small-fit':imageSize == 1, 'medium-fit':imageSize == 2, 
        'large-fit':imageSize == 3, 'fill': questionImageAndMedia.FillFitPostion == 1}">
        <div>
          <div *ngIf="questionImageAndMedia?.Caption != 'BlankImage'">
            <ng-container *ngIf="questionImageAndMedia.IsImage; else MediaControl">
              <div class="question-image-cont-div">
                <app-image-control [imageName]="questionImageAndMedia?.Name"
                  [imagePath]="questionImageAndMedia?.ImagePath"
                  [imageRedirectURL]="questionImageAndMedia?.URL ? questionImageAndMedia.URL : undefined "
                  [imageCaption]="questionImageAndMedia?.Caption? questionImageAndMedia.Caption : undefined ">
                </app-image-control>
              </div>
            </ng-container>
            <ng-template #MediaControl>
              <div [ngClass]="{'audio-file': (questionImageAndMedia.VideoEmbedPath == null)}">
                <div class="question-image-cont-div">
                  <app-media-control [isLoadFile]="questionImageAndMedia?.IsLoadFile"
                    [mediaName]="questionImageAndMedia?.Name" [mediaUrl]="questionImageAndMedia?.URL"
                    [mediaEmbed]="questionImageAndMedia?.VideoEmbedPath"
                    [mediaCaption]="questionImageAndMedia?.Caption ? questionImageAndMedia.Caption : undefined">
                  </app-media-control>
                </div>
              </div>
            </ng-template>
            <div *ngIf="questionImageAndMedia.Caption != 'BlankImage' &&
              questionImageAndMedia.Caption != null" class="caption">
              {{questionImageAndMedia.Caption}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #BestFitHandling>
      <div *ngFor="let questionImageAndMedia of imagesArr; let j = index" class="ques-img-row-item best-fit" [ngClass]="{'align-l': (questionImageAndMedias.length == 1 && questionImageAndMedia.HPosition == 1),
       'align-c':( questionImageAndMedias.length == 1 && questionImageAndMedia.HPosition == 2),
        'align-r': (questionImageAndMedias.length == 1 && questionImageAndMedia.HPosition == 3),
        'one-image': imagesArr.length == 1, 'two-image':  imagesArr.length == 2,
        'three-image': imagesArr.length == 3, 'fill': questionImageAndMedia.FillFitPostion == 1}">
        <div>
          <div *ngIf="questionImageAndMedia?.Caption != 'BlankImage'">
            <ng-container *ngIf="questionImageAndMedia.IsImage; else MediaControl">
              <div class="question-image-cont-div">
                <app-image-control [imageName]="questionImageAndMedia?.Name"
                  [imagePath]="questionImageAndMedia?.ImagePath"
                  [imageRedirectURL]="questionImageAndMedia?.URL ? questionImageAndMedia.URL : undefined "
                  [imageCaption]="questionImageAndMedia?.Caption? questionImageAndMedia.Caption : undefined ">
                </app-image-control>
              </div>
            </ng-container>
            <ng-template #MediaControl>
              <div [ngClass]="{'audio-file': (questionImageAndMedia.VideoEmbedPath == null)}">
                <div class="question-image-cont-div">
                  <app-media-control [isLoadFile]="questionImageAndMedia?.IsLoadFile"
                    [mediaName]="questionImageAndMedia?.Name" [mediaUrl]="questionImageAndMedia?.URL"
                    [mediaEmbed]="questionImageAndMedia?.VideoEmbedPath"
                    [mediaCaption]="questionImageAndMedia?.Caption ? questionImageAndMedia.Caption : undefined">
                  </app-media-control>
                </div>
              </div>
            </ng-template>
            <div *ngIf="questionImageAndMedia.Caption != 'BlankImage' &&
              questionImageAndMedia.Caption != null" class="caption">
              {{questionImageAndMedia.Caption}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>
